import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

const GenericPlaceholder = ({ componentName }) => (
  <div className="generic-placeholder-component">{componentName}</div>
);

GenericPlaceholder.propTypes = {
  componentName: PropTypes.string.isRequired,
};

export default GenericPlaceholder;
